import Trans from 'components/atomic/Trans'
import Link from 'next/link'

function BoxTagCloud({
  title = '',
  description = '',
  tags = [],
  baseHref = '',
  variant = 'white',
}) {
  return (
    <div className={`box-tag-cloud box-tag-cloud--${variant} w-container-hub`}>
      <div className={`box-tag-cloud__content`}>
        <p className="box-tag-cloud__title">
          <Trans chiave={title} />
        </p>
        <p className="box-tag-cloud__description">
          <Trans chiave={description} />
        </p>
        {tags.length ? (
          <div className="box-tag-cloud__cloud">
            {tags.map((tag) => (
              <Link legacyBehavior href={`${baseHref}/${tag.id}`} key={tag.id}>
                <a className="box-tag-cloud__cloud__item">{tag.nome}</a>
              </Link>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default BoxTagCloud
